module.exports = __webpack_public_path__ + "img/add.b94234da.png";